export default "\r\n"